'use es6';

import { I18N_FETCH } from 'DesignData/actions/ActionTypes';
import * as i18nClient from 'DesignData/api/I18n';
export function fetchI18nInfo() {
  const {
    request,
    receive,
    error
  } = fetchI18nInfo;
  return dispatch => {
    dispatch(request());
    i18nClient.fetch().then(response => {
      dispatch(receive(response));
    }).catch(__error => {
      dispatch(error(__error));
    });
  };
}

fetchI18nInfo.request = () => {
  return {
    type: I18N_FETCH
  };
};

fetchI18nInfo.receive = i18nInfo => {
  return {
    type: I18N_FETCH,
    i18nInfo
  };
};

fetchI18nInfo.error = error => {
  return {
    type: I18N_FETCH,
    error
  };
};